import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Label, Input, InputGroup, InputGroupText, InputGroupAddon } from "reactstrap";

const NumericSection = ({
  showError,
  title,
  value,
  onChange,
  negativePrepend,
  canEdit,
  append,
  isValidChange,
  required
}) => {
  const initialValue = value ? `${value}`.replace(".", ",") : "";
  const [numericValue, setNumericValue] = useState(initialValue);
  const [anyValue, setAnyValue] = useState(initialValue);
  const [invalidValue, setInvalidValue] = useState(false);
  useEffect(() => {
    const cleanValue = anyValue || "";
    const withDecimalDots = cleanValue.replace(",", ".");
    setNumericValue(withDecimalDots);
  }, [anyValue]);
  // no incluimos onChange para evitar renderizados infinotos
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    onChange(numericValue);
    const isInvalid = !Number(numericValue);
    setInvalidValue(isInvalid);
    isValidChange(!isInvalid);
  }, [isValidChange, numericValue, onChange, showError]);
  return (
    <div className="col-12 mb-3">
      <Label className={(invalidValue && showError) && "text-danger"}>
        {title}
        {required && <span className="text-danger"> * </span>}
      </Label>
      <InputGroup className="col-12 p-0">
        {negativePrepend && (
          <InputGroupAddon addonType="prepend">
            <InputGroupText>-</InputGroupText>
          </InputGroupAddon>
        )}
        <Input
          lang="es"
          value={anyValue}
          onChange={event => {
            let { value: inputValue } = event.target;
            inputValue = inputValue.replace(/[A-Za-z]+/g, "");
            setAnyValue(inputValue.replace(".", ""));
          }}
          invalid={invalidValue && showError}
          disabled={canEdit}
        />
        <InputGroupAddon addonType="append">
          <InputGroupText>{append}</InputGroupText>
        </InputGroupAddon>
        {(invalidValue && showError) && <div className="invalid-feedback">Importe invalido.</div>}
      </InputGroup>
    </div>
  );
};

NumericSection.propTypes = {
  showError: PropTypes.bool,
  required: PropTypes.bool,
  title: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  canEdit: PropTypes.bool,
  negativePrepend: PropTypes.bool,
  append: PropTypes.string,
  isValidChange: PropTypes.func
};
NumericSection.defaultProps = {
  required: false,
  showError: false,
  title: "",
  value: "",
  onChange: () => {},
  canEdit: true,
  negativePrepend: false,
  append: "EUR",
  isValidChange: () => {}
};
export default NumericSection;
